import ImgTeam1 from "../../assets/Home/ourTeam/our1.png";
import ImgTeam2 from "../../assets/Home/ourTeam/our2.png";
import ImgTeam3 from "../../assets/Home/ourTeam/our3.png";
import ImgTeam4 from "../../assets/Home/ourTeam/our4.png";

// Quyền begin changing
import ImgPartNert1 from "../../assets/Home/OurPartners/IMAGE.png";
import ImgPartNert2 from "../../assets/Home/OurPartners/IMAGE-1.png";
import ImgPartNert3 from "../../assets/Home/OurPartners/IMAGE-2.png";
import ImgPartNert4 from "../../assets/Home/OurPartners/IMAGE-3.png";
import ImgPartNert5 from "../../assets/Home/OurPartners/IMAGE-4.png";
import ImgPartNert6 from "../../assets/Home/OurPartners/IMAGE-5.png";
import ImgPartNert7 from "../../assets/Home/OurPartners/IMAGE-6.png";
import ImgPartNert8 from "../../assets/Home/OurPartners/IMAGE-7.png";
import ImgPartNert9 from "../../assets/Home/OurPartners/IMAGE-8.png";
import ImgPartNert10 from "../../assets/Home/OurPartners/IMAGE-9.png";
import IconInductry5 from "../../assets/Home/IndustryExpertise/b2b.svg";
import IconInductry1 from "../../assets/Home/IndustryExpertise/bank.svg";
import IconInductry3 from "../../assets/Home/IndustryExpertise/education.svg";
import IconInductry6 from "../../assets/Home/IndustryExpertise/estate.svg";
import IconInductry2 from "../../assets/Home/IndustryExpertise/health.svg";
import IconInductry4 from "../../assets/Home/IndustryExpertise/logistic.svg";
import IconInductry7 from "../../assets/Home/IndustryExpertise/travel.svg";
import IconInductry8 from "../../assets/Home/IndustryExpertise/utillities.svg";
//end change

export const ArrInfroBanner = [
  {
    id: `0`,
    number: `7+`,
    title: `Years experience in \nsoftware development`,
  },
  {
    id: `1`,
    number: `50+`,
    title: `Top experts in \nsoftware development `,
  },
  {
    id: `2`,
    number: `70+`,
    title: `Projects Orbit \nsuccessfully completed `,
  },
  {
    id: `3`,
    number: `99%`,
    title: `Positive feedback \nfrom our partners `,
  },
];

export const ArrBlockhainDev = [
  {
    id: `01`,
    title: `WEBSITE APPLICATION`,
  },
  {
    id: `02`,
    title: `UI/UX Design`,
  },
  {
    id: `03`,
    title: `MOBILE APP APPLICATION`,
  },
  {
    id: `04`,
    title: `DevOps`,
  },
  {
    id: `05`,
    title: `BRAND DESIGN`,
  },
  {
    id: `06`,
    title: `DIGITAL MARKETING`,
  },
];

export const ArrWithTechnologyOrbit = [
  {
    id: 0,
    icon: IconInductry1,
    title: `Banking & Finance`,
    des: `Stock market trading platform; Hyperledger smart-contract application for retail banking.`,
  },
  {
    id: 1,
    icon: IconInductry2,
    title: `Social Network `,
    des: `When deciding which social networking platform is best for your business, it’s important to understand the specific needs of your target audience.`,
  },
  {
    id: 2,
    icon: IconInductry3,
    title: `Education`,
    des: `Online learning system; University ERP; Education Games for Kids; Mental Buzzles & Education`,
  },
  {
    id: 3,
    icon: IconInductry4,
    title: `Logistic`,
    des: `Logistic management system; Warehouse management system`,
  },
  {
    id: 4,
    icon: IconInductry5,
    title: `Retailer, B2B, B2C`,
    des: `Market-place solution; Omni-Channel management system; Integration of e-commerce, WMS and CRM.`,
  },
  {
    id: 5,
    icon: IconInductry6,
    title: `Real Estate`,
    des: `Real estate management system; Interior design market-place; Sub-contractor management system.`,
  },
  {
    id: 6,
    icon: IconInductry7,
    title: `Leisure & Travel`,
    des: `Travel portal; Tour booking; Social networks; Dating systems; Games; Music stores, Movie streamer.`,
  },
  {
    id: 7,
    icon: IconInductry8,
    title: `ERP`,
    des: `Enterprise resource planning (ERP) is a software system that helps you run your entire business, supporting automation and processes in finance, human resources,...`,
  },
];

export const ArrOurTeams = [
  {
    id: 0,
    src: ImgTeam1,
    name: `John Smith`,
    info: `CEO`,
  },
  {
    id: 1,
    src: ImgTeam2,
    name: `Thai Mien`,
    info: `Senior Web Developer`,
  },
  {
    id: 2,
    src: ImgTeam3,
    name: `Huong Thao`,
    info: `Mobile Developer`,
  },
  {
    id: 3,
    src: ImgTeam4,
    name: `Thanh Hieu`,
    info: `Brand Designer`,
  },
];

export const ArrFaq = () => {
  return [
    {
      title: `Do you provide blockchain project development consulting?`,
      description: [
        `Yes. We have a consultant team to give you the most suitable solution for your startup/enterprise. We are helpful about creation and management of complex assets, including currencies, rights, serial numbers, patents, etc.`,
        ` We also ensure that data is only available to those who have permission to see and no exception. Our team can also build a platform that can scale to hundreds of thousands of transactions per second.`
      ],
    },
    {
      title: `Do you make custom blockchain development?`,
      description: [
        `Orbit is a software development company with an emphasis on blockchain technology. Custom outsourcing blockchain development for startups and enterprises is our main focus.`,
      ],
    },
    {
      title: `Do you offer blockchain application development?`,
      description: [
        `Yes. Orbit specializes in decentralized applications development. Our main focus is turned to DEX, CEX, staking platforms, crypto wallets, crypto games and decentralized exchanges.`,
      ],
    },
    {
      title: `What blockchain technologies do you work with?`,
      description: [
        `Our developers specialize in the following blockchain technologies: BSCStation, KDG, …`,
      ],
    },
    {
      title: `Where is your blockchain software development company located?`,
      description: [
        `Orbit Technology Located in Go Vap, Ho Chi Minh city. Our BD is ready to meet you at any location worldwide. `,
      ],
    },
    {
      title: `Do you provide project support & maintenance services?`,
      description: [
        `Yes. Orbit offers a variety of solutions that further can be maintained by our blockchain development team post product launch and moreover.`,
      ],
    },
  ];
};


// Quyền Change
export const ArrImgListPartnerts = [
  {
    img: ImgPartNert1,
    link:`https://4irelabs.com/`
  },
  {
    img: ImgPartNert2,
    link:`https://dehive.finance/`
  },
  {
    img: ImgPartNert3,
    link:`https://everstake.one/`
  },
  {
    img: ImgPartNert4,
    link:`https://hackless.io/`
  },
  {
    img: ImgPartNert5,
    link:`https://solana.com`
  },
  {
    img: ImgPartNert6,
    link:`https://atticlab.net/`
  },
  {
    img: ImgPartNert7,
    link:`https://www.qubicles.io/`
  },
  {
    img: ImgPartNert8,
    link:`https://breaker.io/`
  },
  {
    img: ImgPartNert9,
    link:`https://www.zokyo.io/`
  },
  {
    img: ImgPartNert10,
    link:`https://hackless.io/`
  },
]